"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var LABEL_WIDTH = 42;
var LABEL_HEIGHT = 24;
var LABEL_MARGIN_BOTTOM = 12;
var TEXT_HEIGHT = 8;
function BarLabelCircle(_a) {
    var displayValue = _a.displayValue, props = __rest(_a, ["displayValue"]);
    var x = props.x, y = props.y, index = props.index, width = props.width;
    if (index === 0)
        return null;
    return (react_1.default.createElement("g", { transform: "translate(".concat(x + width / 2 + 1, ", ").concat(y, ")") },
        react_1.default.createElement("rect", { xmlns: "http://www.w3.org/2000/svg", className: "chart-custom__label-circle background", x: -LABEL_WIDTH / 2, y: -LABEL_MARGIN_BOTTOM - LABEL_HEIGHT, rx: "12", ry: "12" }),
        react_1.default.createElement(kaleidoscope_1.Label, { className: "chart-custom__label-circle chart__label", element: "text", x: 1, y: -LABEL_MARGIN_BOTTOM - TEXT_HEIGHT }, displayValue)));
}
exports.default = BarLabelCircle;
